/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

/**
 * Telugu strings — initial machine-assisted draft, pending translation-vendor
 * review (tracked as dependency E8). Missing keys fall back to English.
 */
const CLIENT = 'క్లయింట్';
const SESSIONS = 'సెషన్లు';
const THERAPIST = 'థెరపిస్ట్';
const STATUS = 'స్థితి';
const PLAN = 'ప్లాన్';
const MRR = 'MRR';
const TRIAL = 'ట్రయల్';
const SUBSCRIPTION = 'సబ్‌స్క్రిప్షన్';
const ACTION = 'చర్య';
const NO_SESSIONS = 'షెడ్యూల్ చేసిన సెషన్లు లేవు.';
const THERAPY_PLANS = 'థెరపీ ప్లాన్‌లు';
const REPORTS = 'నివేదికలు';
const HOME_TASKS = 'ఇంటి పనులు';
const SELECT_A_CLIENT = 'క్లయింట్‌ను ఎంచుకోండి';
const TYPE = 'రకం';
const TIME = 'సమయం';
const ACTIONS = 'చర్యలు';
const PROGRESS = 'పురోగతి';
const CITY = 'నగరం';
const STATE_LABEL = 'రాష్ట్రం';
const POSTAL_CODE = 'పిన్ కోడ్';
const LEGAL_NAME = 'చట్టపరమైన పేరు';
const CONTACT_EMAIL = 'సంప్రదింపు ఇమెయిల్';
const CONTACT_PHONE = 'సంప్రదింపు ఫోన్';
const TIMEZONE = 'టైమ్‌జోన్';
const AMOUNT_RUPEES = 'మొత్తం (₹)';
const FULL_NAME = 'పూర్తి పేరు';
const EMAIL = 'ఇమెయిల్';
const PHONE = 'ఫోన్';
const PARENT_FULL_NAME = 'తల్లిదండ్రుల పూర్తి పేరు';
const PARENT_EMAIL = 'తల్లిదండ్రుల ఇమెయిల్';
const ACTIVE = 'యాక్టివ్';
const SUSPENDED = 'నిలిపివేయబడింది';
const CANCELLED = 'రద్దు చేయబడింది';
const NO_INVOICES = 'ఇన్‌వాయిస్‌లు లేవు.';
const DRAFT = 'డ్రాఫ్ట్';
const PAID = 'చెల్లించబడింది';
const ADD_LINE_1 = 'చిరునామా లైన్ 1';
const COUNTRY_ISO = 'దేశం (ISO)';
const REPORTS_COUNT = '{{count}} నివేదికలు';
const CURRENT_GOALS = 'ప్రస్తుత లక్ష్యాలు';
const SUB_TARGETS = 'ఉప-లక్ష్యాలు';
const SAVE_CHANGES = 'మార్పులను సేవ్ చేయి';
const FILTER_BY_STATUS = 'స్థితి ద్వారా ఫిల్టర్';
const ALL_STATUS = 'అన్ని స్థితులు';

export default {
  common: {
    appName: 'TherapyOS',
    loading: 'లోడ్ అవుతోంది…',
    save: SAVE_CHANGES,
    cancel: 'రద్దు',
    signOut: 'లాగౌట్',
    search: 'వెతుకు…',
    notFound: 'పేజీ కనుగొనబడలేదు',
    backHome: 'హోమ్‌కు తిరిగి',
    loadError: 'డేటాను లోడ్ చేయలేకపోయాం. దయచేసి మళ్ళీ ప్రయత్నించండి.',
    saveError: 'సేవ్ చేయలేకపోయాం. దయచేసి ఫారమ్‌ను తనిఖీ చేసి మళ్ళీ ప్రయత్నించండి.',
    view: 'చూడు',
    edit: 'సవరించు',
    delete: 'తొలగించు',
  },
  topbar: {
    back: 'వెనక్కి వెళ్ళు',
    welcome: 'తిరిగి స్వాగతం',
    welcomeName: 'తిరిగి స్వాగతం, {{name}}',
    addNew: 'కొత్తది జోడించు',
    notifications: 'నోటిఫికేషన్లు',
    noNotifications: 'కొత్త నోటిఫికేషన్లు లేవు',
    toggleTheme: 'డార్క్ మోడ్‌ను మార్చు',
  },
  status: {
    active: ACTIVE,
    inactive: 'నిష్క్రియం',
    discharged: 'డిశ్చార్జ్ అయింది',
    scheduled: 'షెడ్యూల్ చేయబడింది',
    in_progress: 'జరుగుతోంది',
    completed: 'పూర్తయింది',
    cancelled: 'రద్దు',
    no_show: 'హాజరు కాలేదు',
  },
  goalStatus: {
    not_started: 'ప్రారంభం కాలేదు',
    emerging: 'ఉద్భవిస్తోంది',
    in_progress: 'జరుగుతోంది',
    achieved: 'సాధించబడింది',
    maintenance: 'నిర్వహణ',
    discontinued: 'నిలిపివేయబడింది',
  },
  measurementType: {
    frequency: 'పౌనఃపున్యం',
    percent_accuracy: 'శాతం ఖచ్చితత్వం',
    duration: 'వ్యవధి',
    latency: 'జాప్యం',
    trials_to_criterion: 'ప్రమాణం వరకు ప్రయత్నాలు',
    rating_scale: 'రేటింగ్ స్కేల్',
    independence_level: 'స్వాతంత్ర్య స్థాయి',
    prompt_level: 'సూచన స్థాయి',
    anecdotal: 'వివరణాత్మక',
  },
  sessionType: {
    individual: 'వ్యక్తిగత',
    group: 'సమూహం',
    teletherapy: 'టెలిథెరపీ',
    assessment: 'మూల్యాంకనం',
    review: 'సమీక్ష',
    supervision: 'పర్యవేక్షణ',
    home_visit: 'ఇంటి సందర్శన',
  },
  therapist: {
    dashboard: {
      myClients: 'నా క్లయింట్లు',
      upcoming: 'రాబోయే సెషన్లు',
      plans: THERAPY_PLANS,
    },
    clients: {
      title: 'నా క్లయింట్లు',
      count: '{{count}} క్లయింట్లు',
      searchPlaceholder: 'క్లయింట్లను వెతుకు…',
      empty: 'ఇంకా క్లయింట్లు కేటాయించబడలేదు.',
    },
    notes: {
      title: 'సెషన్ గమనికలు',
      subtitle: 'మీ సెషన్లను డాక్యుమెంట్ చేయండి',
      count: 'డాక్యుమెంట్ చేయడానికి {{count}} సెషన్లు',
      empty: 'ఇంకా డాక్యుమెంట్ చేయడానికి సెషన్లు లేవు.',
      open: 'గమనికను తెరువు',
    },
    schedule: {
      title: 'షెడ్యూల్',
      subtitle: 'మీ వారపు సెషన్ క్యాలెండర్',
      add: 'కొత్త సెషన్',
      empty: 'రాబోయే సెషన్లు లేవు.',
      noneDay: 'సెషన్లు లేవు',
      prevWeek: 'మునుపటి వారం',
      nextWeek: 'తదుపరి వారం',
      thisWeek: 'ఈ వారం',
    },
    availability: {
      title: 'లభ్యత',
      subtitle: 'మీ పునరావృత వారపు పని గంటలు',
      save: 'లభ్యతను సేవ్ చేయి',
      saved: 'లభ్యత సేవ్ చేయబడింది.',
      saveError: 'లభ్యతను సేవ్ చేయలేకపోయాం. దయచేసి మళ్ళీ ప్రయత్నించండి.',
      invalid:
        'మీ సమయ విండోలను తనిఖీ చేయండి — ముగింపు ప్రారంభం తర్వాత ఉండాలి మరియు విండోలు అతివ్యాప్తి చెందకూడదు.',
      addWindow: 'విండో జోడించు',
      removeWindow: 'విండో తొలగించు',
      none: 'అందుబాటులో లేదు',
      days: {
        mon: 'సోమవారం',
        tue: 'మంగళవారం',
        wed: 'బుధవారం',
        thu: 'గురువారం',
        fri: 'శుక్రవారం',
        sat: 'శనివారం',
        sun: 'ఆదివారం',
      },
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'నేటి సెషన్లు మరియు జీవితచక్రం',
      empty: NO_SESSIONS,
      colClient: CLIENT,
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
      colActions: ACTIONS,
      start: 'ప్రారంభించు',
      complete: 'పూర్తి చేయి',
      cancel: 'రద్దు',
      reschedule: 'రీషెడ్యూల్',
      note: 'సెషన్ గమనిక',
      rate: 'రేట్ చేయండి',
      rescheduleTitle: 'సెషన్‌ను రీషెడ్యూల్ చేయి',
      rescheduleSubtitle:
        'కొత్త సమయాన్ని ఎంచుకోండి. థెరపిస్ట్ యొక్క ఇతర సెషన్లతో ఘర్షణలు తిరస్కరించబడతాయి.',
    },
    rate: {
      title: 'సెషన్‌ను రేట్ చేయండి',
      subtitle: 'నిమగ్నత, సహకారం మరియు సందర్భం',
      engagement: 'నిమగ్నత',
      cooperation: 'సహకారం',
      note: 'సందర్భ గమనిక',
      unrated: 'రేట్ చేయలేదు',
      submit: 'రేటింగ్‌ను సేవ్ చేయండి',
    },
    note: {
      title: 'సెషన్ గమనిక',
      back: 'సెషన్లకు తిరిగి',
      signed: 'సంతకం చేయబడింది',
      trials: 'లక్ష్య ట్రయల్ డేటా',
      correct: 'సరైనది',
      incorrect: 'తప్పు',
      prompted: 'ప్రాంప్ట్ చేయబడింది',
      subjective: 'వ్యక్తిగతం',
      objective: 'వస్తుగతం',
      assessment: 'మదింపు',
      plan: PLAN,
      saveDraft: 'డ్రాఫ్ట్ సేవ్ చేయి',
      sign: 'సంతకం చేసి లాక్ చేయి',
    },
    plans: {
      title: THERAPY_PLANS,
      subtitle: 'మీ క్లయింట్ల కోసం వ్యక్తిగత థెరపీ ప్లాన్‌లు',
      count: '{{count}} యాక్టివ్ ప్లాన్‌లు',
      searchPlaceholder: 'పేరు ద్వారా ప్లాన్‌లను వెతుకు…',
      empty: 'ఇంకా థెరపీ ప్లాన్‌లు లేవు.',
      progress: 'మొత్తం పురోగతి',
      review: 'సమీక్ష',
      reviewDate: 'సమీక్ష తేదీ',
      currentGoals: CURRENT_GOALS,
      moreGoals: '+{{count}} మరిన్ని',
      viewDetails: 'వివరాలను చూడు',
      updateProgress: 'పురోగతిని నవీకరించు',
      detailsTitle: 'థెరపీ ప్లాన్ వివరాలు',
      client: CLIENT,
      program: 'ప్రోగ్రామ్',
      startDate: 'ప్రారంభ తేదీ',
      goals: 'లక్ష్యాలు',
    },
    planForm: {
      newPlan: 'కొత్త ప్లాన్',
      subtitle: 'క్లయింట్ కోసం థెరపీ ప్లాన్ మరియు దాని లక్ష్యాలను రూపొందించండి.',
      fromTemplate: 'టెంప్లేట్ నుండి ప్రారంభించు',
      fromTemplateNone: 'టెంప్లేట్ లేదు — ఖాళీగా ప్రారంభించు',
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      name: 'ప్లాన్ పేరు',
      programType: 'ప్రోగ్రామ్ రకం',
      startDate: 'ప్రారంభ తేదీ',
      reviewDate: 'సమీక్ష తేదీ',
      goals: 'లక్ష్యాలు',
      addGoal: 'లక్ష్యం జోడించు',
      goalN: 'లక్ష్యం {{n}}',
      goalTitle: 'లక్ష్యం',
      domain: 'రంగం',
      selectDomain: 'రంగాన్ని ఎంచుకోండి',
      measurementType: 'కొలత విధానం',
      selectMeasurementType: 'విధానాన్ని ఎంచుకోండి',
      measure: 'కొలత వివరం',
      baseline: 'బేస్‌లైన్',
      target: 'లక్ష్యం',
      goalReviewDate: 'లక్ష్య సమీక్ష తేదీ',
      approachTags: 'విధాన ట్యాగ్‌లు',
      approachTagsHint: 'కామాతో వేరు చేయబడింది, ఉదా. PECS, DTT',
      subTargets: SUB_TARGETS,
      subTargetsHint: '; తో వేరు చేయండి — > తర్వాత దశలను జోడించండి, ఉదా. అనుకరణ > మోడల్, సూచన',
      removeGoal: 'లక్ష్యం తొలగించు',
      submit: 'ప్లాన్ సృష్టించు',
    },
    plan: {
      back: 'ప్లాన్‌లకు తిరిగి',
      goals: CURRENT_GOALS,
      noGoals: 'ఈ ప్లాన్‌లో ఇంకా లక్ష్యాలు లేవు.',
      updateStatus: 'లక్ష్య స్థితిని నవీకరించు',
      subTargets: SUB_TARGETS,
      reviewBy: '{{date}} లోపు సమీక్ష',
      statusNote: 'స్థితి-మార్పు గమనిక (ఐచ్ఛికం)',
      statusNotePlaceholder: 'స్థితి ఎందుకు మారుతోంది?',
      history: 'స్థితి చరిత్ర',
      showHistory: 'స్థితి చరిత్ర',
      hideHistory: 'చరిత్రను దాచు',
      noHistory: 'ఇంకా ఏ స్థితి మార్పు నమోదు కాలేదు.',
      historyEntry: '{{from}} → {{to}}',
      historyInitial: '{{to}} గా సెట్ చేయబడింది',
      saveAsTemplate: 'టెంప్లేట్‌గా సేవ్ చేయి',
      exportPdf: 'PDF ఎగుమతి',
      exporting: 'ఎగుమతి అవుతోంది…',
      saveTemplateTitle: 'టెంప్లేట్‌గా సేవ్ చేయి',
      saveTemplateSubtitle:
        'భవిష్యత్ ప్లాన్‌లను సృష్టించేటప్పుడు ఈ ప్లాన్ లక్ష్యాలను తిరిగి ఉపయోగించండి.',
      templateName: 'టెంప్లేట్ పేరు',
    },
    templates: {
      title: 'టెంప్లేట్‌లు',
      subtitle: 'మీ క్లినిక్ కోసం తిరిగి ఉపయోగించదగిన ప్లాన్ లక్ష్య సెట్‌లు',
      empty:
        'ఇంకా టెంప్లేట్‌లు లేవు. లక్ష్యాలను తిరిగి ఉపయోగించడానికి ప్లాన్‌ను టెంప్లేట్‌గా సేవ్ చేయండి.',
      goalCount: '{{count}} లక్ష్యాలు',
      delete: 'టెంప్లేట్ తొలగించు',
    },
    collaborators: {
      title: 'సహకరిస్తున్న థెరపిస్ట్‌లు',
      none: 'ఇంకా సహకారులు లేరు.',
      add: 'సహకారిని జోడించు…',
      remove: 'సహకారిని తొలగించు',
    },
    review: {
      title: 'క్లినికల్ సమీక్షలు',
      due: 'సమీక్ష గడువు',
      dueBanner: '{{count}} ప్రణాళికలు క్లినికల్ సమీక్షకు గడువు చేరాయి',
      record: 'సమీక్షను నమోదు చేయి',
      empty: 'ఇప్పటివరకు సమీక్షలు నమోదు కాలేదు.',
      modalTitle: 'క్లినికల్ సమీక్షను నమోదు చేయి',
      modalSubtitle: 'సమీక్ష ఫలితాన్ని నమోదు చేసి తదుపరి సమీక్ష తేదీని సెట్ చేయండి.',
      outcome: 'ఫలితం',
      outcome_continue: 'ప్రణాళికను కొనసాగించు',
      outcome_revise: 'ప్రణాళికను సవరించు',
      outcome_discharge: 'డిశ్చార్జ్',
      summary: 'సారాంశం',
      recommendations: 'సిఫార్సులు (ఐచ్ఛికం)',
      nextDate: 'తదుపరి సమీక్ష తేదీ',
      submit: 'సమీక్షను సేవ్ చేయి',
    },
    homeTasks: {
      link: HOME_TASKS,
      back: 'నా క్లయింట్లకు తిరిగి',
      title: HOME_TASKS,
      subtitle: 'ఇంటి-ప్రోగ్రామ్ పనులను కేటాయించి సమీక్షించండి',
    },
  },
  parent: {
    selectChild: 'పిల్లవాడు',
    noData: 'ఇంకా డేటా నమోదు చేయబడలేదు',
    dashboard: {
      title: 'స్వాగతం',
      subtitle: 'మీ పిల్లల థెరపీ ఒక్క చూపులో',
      empty: 'ఇంకా పిల్లలు ఎవరూ నమోదు చేయబడలేదు.',
      progress: 'మొత్తం పురోగతి',
      viewProgress: 'పురోగతిని చూడు →',
      recentReports: 'ఇటీవలి నివేదికలు',
    },
    achievements: {
      dayStreak: '{{count}} రోజుల వరుస',
      completed: '{{count}} పూర్తయింది',
      badge: {
        firstStep: 'మొదటి అడుగు',
        threeDay: '3-రోజుల వరుస',
        weekWarrior: 'వారం యోధుడు',
        fiftyDone: '50 పూర్తయింది',
      },
    },
    progress: {
      title: PROGRESS,
      subtitle: 'కాలక్రమేణా లక్ష్య ఖచ్చితత్వం',
      empty: 'ఇంకా పురోగతి డేటా నమోదు చేయబడలేదు.',
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'మీ పిల్లల థెరపీ షెడ్యూల్',
      empty: NO_SESSIONS,
      colChild: 'పిల్లవాడు',
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
    },
    billing: {
      title: 'బిల్లింగ్',
      subtitle: 'మీ ఇన్‌వాయిస్‌లు మరియు చెల్లింపులు',
      empty: NO_INVOICES,
      payNow: 'ఇప్పుడు చెల్లించు',
      payNowTitle: 'ఇన్‌వాయిస్ చెల్లించు',
      payNowSubtitle: 'బకాయి మొత్తాన్ని సురక్షితంగా చెల్లించండి (Razorpay).',
      payConfirm: 'ఇప్పుడు చెల్లించు',
      paying: 'ప్రాసెస్ అవుతోంది…',
      payError: 'చెల్లింపు ప్రాసెస్ చేయలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.',
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
      empty: 'మీతో ఇంకా ఏ నివేదికలు పంచుకోబడలేదు.',
    },
    homeTasks: {
      title: HOME_TASKS,
      subtitle: 'నేటి ఇంటి థెరపీ సాధన',
      dailyProgress: 'రోజువారీ పురోగతి',
      completedCount: '{{done}} లో {{total}} నేడు పూర్తయింది',
      completed: 'పూర్తయింది ✓',
      dueToday: 'నేడు చేయవలసినది',
      markDone: 'పూర్తయినట్లు గుర్తించు',
      empty: 'ఇంకా ఇంటి పనులు కేటాయించబడలేదు.',
    },
  },
  admin: {
    dashboard: {
      activeClients: 'యాక్టివ్ క్లయింట్లు',
      therapists: 'థెరపిస్ట్‌లు',
      sessions: SESSIONS,
      sessionsThisMonth: 'ఈ నెల సెషన్లు',
      avgProgress: 'సగటు ప్లాన్ పురోగతి',
      plans: THERAPY_PLANS,
      distribution: 'క్లయింట్ పంపిణీ',
      distributionSub: 'థెరపీ రకం ప్రకారం',
      sessionsTrend: 'సెషన్లు',
      sessionsTrendSub: 'గత 6 నెలలు',
      performance: 'థెరపిస్ట్ పనితీరు',
      performanceSub: 'అగ్ర ప్రదర్శనకారులు',
      sessionsUnit: '{{count}} సెషన్లు',
      upcoming: 'రాబోయే సెషన్లు',
      upcomingSub: 'నేటి షెడ్యూల్',
      noUpcoming: 'రాబోయే సెషన్లు లేవు.',
      noData: 'ఇంకా డేటా లేదు.',
      viewAll: 'అన్నీ చూడు',
      activity: 'ఇటీవలి కార్యకలాపం',
      activitySub: 'ఇటీవల పూర్తయిన సెషన్లు',
      noActivity: 'ఇటీవలి కార్యకలాపం లేదు.',
      activitySession: '{{client}} ఒక సెషన్‌ను పూర్తి చేశారు',
    },
    clients: {
      title: 'క్లయింట్ నిర్వహణ',
      subtitle: 'మీ క్లినిక్‌లో నమోదైన పిల్లలు',
      count: 'మొత్తం {{count}} క్లయింట్లు',
      add: 'క్లయింట్ జోడించు',
      edit: 'క్లయింట్ సవరించు',
      addSubtitle: 'కొత్త క్లయింట్ రికార్డ్‌ను సృష్టించు',
      empty: 'ఇంకా క్లయింట్లు లేరు. ప్రారంభించడానికి మీ మొదటి క్లయింట్‌ను జోడించండి.',
      searchPlaceholder: 'క్లయింట్లు, రోగనిర్ధారణ, థెరపిస్ట్‌ను వెతుకు…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      age: 'వయస్సు {{age}}',
      colName: CLIENT,
      colDiagnosis: 'రోగనిర్ధారణ',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colProgress: PROGRESS,
      colStatus: STATUS,
      colActions: ACTIONS,
      deleteTitle: 'క్లయింట్‌ను తొలగించాలా?',
      deleteBody: '{{name}} మరియు వారి అన్ని రికార్డులను శాశ్వతంగా తొలగించు. దీన్ని రద్దు చేయలేరు.',
    },
    clientDetail: {
      back: 'క్లయింట్లకు తిరిగి',
      notFound: 'క్లయింట్ కనుగొనబడలేదు.',
      age: 'వయస్సు',
      therapist: THERAPIST,
      guardian: 'సంరక్షకుడు',
      contact: 'సంప్రదింపు',
      plans: THERAPY_PLANS,
      noPlans: 'ఇంకా థెరపీ ప్లాన్‌లు లేవు.',
      sessions: 'ఇటీవలి సెషన్లు',
      noSessions: NO_SESSIONS,
      billing: 'బిల్లింగ్',
      noInvoices: NO_INVOICES,
    },
    sessions: {
      title: SESSIONS,
      count: '{{count}} సెషన్లు',
      empty: NO_SESSIONS,
      searchPlaceholder: 'రకం లేదా స్థలం ద్వారా వెతుకు…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      schedule: 'సెషన్ షెడ్యూల్ చేయి',
      scheduleSubtitle: 'కొత్త థెరపీ సెషన్‌ను బుక్ చేయి',
      colClient: CLIENT,
      colTherapist: THERAPIST,
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
    },
    users: {
      title: 'బృంద సభ్యులు',
      count: 'మొత్తం {{count}} వినియోగదారులు',
      invite: 'వినియోగదారుని ఆహ్వానించండి',
      inviteTitle: 'బృంద సభ్యుని ఆహ్వానించండి',
      inviteSubtitle: 'పాస్‌వర్డ్ సెట్ చేయడానికి వారికి ఇమెయిల్ అందుతుంది.',
      empty: 'ఇంకా బృంద సభ్యులు లేరు. ప్రారంభించడానికి మీ మొదటి వినియోగదారుని ఆహ్వానించండి.',
      enable: 'ప్రారంభించు',
      disable: 'నిలిపివేయి',
      name: FULL_NAME,
      email: EMAIL,
      role: 'పాత్ర',
      inviteError: 'ఆహ్వానం పంపడం సాధ్యం కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.',
      col: {
        name: 'పేరు',
        email: EMAIL,
        roles: 'పాత్రలు',
        status: STATUS,
        lastLogin: 'చివరి లాగిన్',
      },
      role_CLINIC_ADMIN: 'క్లినిక్ అడ్మిన్',
      role_THERAPIST: THERAPIST,
      role_FINANCE: 'ఫైనాన్స్',
      status_invited: 'ఆహ్వానించబడింది',
      status_active: ACTIVE,
      status_disabled: SUSPENDED,
    },
    therapists: {
      title: 'థెరపిస్ట్ నిర్వహణ',
      subtitle: 'మీ క్లినిక్‌లోని క్లినికల్ సిబ్బంది',
      registered: '{{count}} థెరపిస్ట్‌లు నమోదు చేయబడ్డారు',
      add: 'థెరపిస్ట్ జోడించు',
      addSubtitle: 'కొత్త థెరపిస్ట్ ప్రొఫైల్‌ను సృష్టించు',
      empty: 'ఇంకా థెరపిస్ట్‌లు లేరు. ప్రారంభించడానికి మీ మొదటి థెరపిస్ట్‌ను జోడించండి.',
      searchPlaceholder: 'థెరపిస్ట్‌లను వెతుకు…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      clients: 'క్లయింట్లు',
      sessions: SESSIONS,
      rating: 'రేటింగ్',
      joined: '{{date}} న చేరారు',
    },
    finance: {
      title: 'ఫైనాన్స్',
      count: '{{count}} ఇన్‌వాయిస్‌లు',
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
    },
    invite: {
      title: 'తల్లిదండ్రులను ఆహ్వానించు',
      subtitle: 'ఈ పిల్లవాని కోసం తల్లిదండ్రుల లాగిన్‌ను సృష్టించు',
      intro: '{{child}} యొక్క తల్లిదండ్రులకు పేరెంట్ పోర్టల్‌ను యాక్సెస్ చేయడానికి ఆహ్వానం పంపండి.',
      parentName: PARENT_FULL_NAME,
      email: PARENT_EMAIL,
      submit: 'ఆహ్వానం పంపు',
      error: 'ఆహ్వానాన్ని పంపలేకపోయాం. ఇమెయిల్ ఇప్పటికే వాడుకలో ఉండవచ్చు.',
      success: '{{email}} కు ఆహ్వానం ఇమెయిల్ చేయబడింది.',
      linkLabel: 'యాక్టివేషన్ లింక్',
      copy: 'కాపీ',
      copied: 'కాపీ చేయబడింది',
      note: 'మేము ఈ లింక్‌ను తల్లిదండ్రులకు ఇమెయిల్ చేశాము. మీరు దీన్ని కాపీ చేసి పంచుకోవచ్చు — ఇది వారికి పాస్‌వర్డ్ సెట్ చేసి సైన్ ఇన్ చేయడానికి అనుమతిస్తుంది, మరియు 7 రోజుల్లో గడువు ముగుస్తుంది.',
    },
  },
  form: {
    client: {
      fullName: FULL_NAME,
      age: 'వయస్సు',
      primaryDiagnosis: 'రోగనిర్ధారణ',
      email: EMAIL,
      phone: PHONE,
      assignTherapist: 'కేటాయించిన థెరపిస్ట్',
      noTherapist: 'థెరపిస్ట్ కేటాయించబడలేదు',
      submit: 'క్లయింట్ జోడించు',
      guardianName: 'తల్లిదండ్రులు / సంరక్షకుని పేరు',
      inviteParentNow: 'తల్లిదండ్రుల లాగిన్‌ను కూడా సృష్టించు',
      inviteParentHint:
        'పేరెంట్ పోర్టల్‌ను యాక్సెస్ చేయడానికి మేము తల్లిదండ్రులకు యాక్టివేషన్ లింక్‌ను ఇమెయిల్ చేస్తాం.',
      parentName: PARENT_FULL_NAME,
      parentEmail: PARENT_EMAIL,
    },
    therapist: {
      fullName: FULL_NAME,
      email: EMAIL,
      phone: PHONE,
      specialty: 'ప్రత్యేకత',
      specialisations: 'ప్రత్యేకతలు',
      specialisationsHint: 'కామాతో వేరు చేయబడింది, ఉదా. ASD, స్పీచ్, OT',
      joinedOn: 'చేరిన తేదీ',
      submit: 'థెరపిస్ట్ జోడించు',
    },
    session: {
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      therapist: THERAPIST,
      anyTherapist: 'ఏదైనా అందుబాటులో ఉన్న థెరపిస్ట్',
      type: 'సెషన్ రకం',
      typeHint: 'ఉదా. స్పీచ్ థెరపీ',
      anyType: 'ఏదైనా రకం',
      start: 'తేదీ & సమయం',
      submit: 'సెషన్ షెడ్యూల్ చేయి',
    },
    reschedule: {
      start: 'కొత్త తేదీ & సమయం',
      submit: 'రీషెడ్యూల్',
      conflict: 'ఆ సమయం ఈ థెరపిస్ట్ యొక్క మరొక సెషన్‌తో ఘర్షణ పడుతోంది.',
    },
    invoice: {
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      service: 'సేవ',
      serviceCustom: 'అనుకూల మొత్తం',
      amount: AMOUNT_RUPEES,
      amountHint: 'ఉదా. 2500',
      dueDate: 'గడువు తేదీ',
      notes: 'గమనికలు',
      notesHint: 'ఉదా. జూన్ స్పీచ్-థెరపీ సెషన్లు',
      submit: 'ఇన్‌వాయిస్ సృష్టించు',
    },
    payment: {
      balance: 'బాకీ ఉన్న నిల్వ: {{amount}}',
      amount: AMOUNT_RUPEES,
      method: 'చెల్లింపు పద్ధతి',
      selectMethod: 'పద్ధతిని ఎంచుకోండి',
      submit: 'చెల్లింపును నమోదు చేయి',
    },
    homeTask: {
      title: 'పని',
      titleHint: 'ఉదా. ఆట సమయంలో కంటి చూపును సాధన చేయి (10 నిమి)',
      category: 'వర్గం',
      selectCategory: 'వర్గాన్ని ఎంచుకోండి',
      instructions: 'సూచనలు',
      instructionsHint: 'తల్లిదండ్రుల కోసం ఐచ్ఛిక మార్గదర్శకత్వం',
      submit: 'పనిని కేటాయించు',
    },
  },
  login: {
    welcome: 'తిరిగి స్వాగతం',
    subtitle: 'మీ పోర్టల్‌కు సైన్ ఇన్ చేయండి',
    selectRole: 'మీ పాత్రను ఎంచుకోండి',
    email: 'ఇమెయిల్ చిరునామా',
    emailPlaceholder: 'మీ ఇమెయిల్‌ను నమోదు చేయండి',
    password: 'పాస్‌వర్డ్',
    passwordPlaceholder: 'మీ పాస్‌వర్డ్‌ను నమోదు చేయండి',
    signInTo: '{{portal}} కు సైన్ ఇన్ చేయి',
    selectClinic: 'మీ క్లినిక్‌ను ఎంచుకోండి',
    invalidCredentials: 'ఇమెయిల్ లేదా పాస్‌వర్డ్ తప్పు',
    accountLocked: 'ఖాతా తాత్కాలికంగా లాక్ చేయబడింది. తర్వాత మళ్ళీ ప్రయత్నించండి.',
    forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా?',
    roles: {
      CLINIC_ADMIN: { title: 'అడ్మిన్ పోర్టల్', blurb: 'పూర్తి సిస్టమ్ నియంత్రణ మరియు నిర్వహణ' },
      THERAPIST: {
        title: 'థెరపిస్ట్ పోర్టల్',
        blurb: 'క్లయింట్లు మరియు థెరపీ సెషన్లను నిర్వహించు',
      },
      PARENT: { title: 'పేరెంట్ పోర్టల్', blurb: 'మీ పిల్లల పురోగతిని ట్రాక్ చేయి' },
      FINANCE: { title: 'ఫైనాన్స్ పోర్టల్', blurb: 'బిల్లింగ్, ఇన్‌వాయిసింగ్ మరియు పేరోల్' },
    },
    tagline: 'సురక్షితం • DPDP అనుకూలం • ఎంటర్‌ప్రైజ్ గ్రేడ్',
  },
  forgot: {
    title: 'మీ పాస్‌వర్డ్‌ను రీసెట్ చేయండి',
    subtitle: 'మీ ఇమెయిల్‌ను నమోదు చేయండి, మేము మీకు రీసెట్ లింక్‌ను పంపుతాం.',
    submit: 'రీసెట్ లింక్ పంపు',
    sentTitle: 'మీ ఇమెయిల్‌ను తనిఖీ చేయండి',
    sentBody:
      'ఆ ఇమెయిల్‌కు ఖాతా ఉంటే, మీ పాస్‌వర్డ్‌ను రీసెట్ చేయడానికి మేము లింక్‌ను పంపాము. లింక్ 1 గంటలో గడువు ముగుస్తుంది.',
    backToLogin: 'లాగిన్‌కు తిరిగి',
  },
  pagination: {
    prev: 'మునుపటి',
    next: 'తదుపరి',
    pageOf: 'పేజీ {{page}} / {{total}}',
  },
  account: {
    changePassword: {
      title: 'పాస్‌వర్డ్ మార్చు',
      subtitle: 'మీ ఖాతా కోసం పాస్‌వర్డ్‌ను నవీకరించండి.',
      current: 'ప్రస్తుత పాస్‌వర్డ్',
      new: 'కొత్త పాస్‌వర్డ్',
      submit: 'పాస్‌వర్డ్ నవీకరించు',
      success: 'మీ పాస్‌వర్డ్ నవీకరించబడింది.',
      error:
        'మీ పాస్‌వర్డ్‌ను మార్చలేకపోయాం. మీ ప్రస్తుత పాస్‌వర్డ్‌ను తనిఖీ చేసి మళ్ళీ ప్రయత్నించండి.',
    },
  },
  setPassword: {
    title: 'మీ పాస్‌వర్డ్‌ను సెట్ చేయండి',
    subtitle: 'మీ ఖాతాను యాక్టివేట్ చేయడానికి పాస్‌వర్డ్‌ను ఎంచుకోండి.',
    newPassword: 'కొత్త పాస్‌వర్డ్',
    confirmPassword: 'పాస్‌వర్డ్‌ను నిర్ధారించండి',
    submit: 'పాస్‌వర్డ్ సెట్ చేయి',
    missingToken: 'ఈ లింక్ చెల్లదు లేదా దాని టోకెన్ లేదు.',
    error: 'ఈ లింక్ చెల్లదు లేదా గడువు ముగిసింది. దీన్ని మళ్ళీ పంపమని మీ క్లినిక్‌ను అడగండి.',
    doneTitle: 'పాస్‌వర్డ్ సెట్ చేయబడింది',
    doneBody: 'మీ ఖాతా యాక్టివ్‌గా ఉంది. మీరు ఇప్పుడు సైన్ ఇన్ చేయవచ్చు.',
    goToLogin: 'లాగిన్‌కు వెళ్ళు',
  },
  staffLogin: {
    title: 'స్టాఫ్ కన్సోల్',
    subtitle: 'iTech అంతర్గత యాక్సెస్ మాత్రమే',
    totp: 'అథెంటికేటర్ కోడ్',
    totpPlaceholder: '6-అంకెల కోడ్',
    signIn: 'సైన్ ఇన్',
  },
  nav: {
    dashboard: 'డాష్‌బోర్డ్',
    clients: 'క్లయింట్లు',
    therapists: 'థెరపిస్ట్‌లు',
    sessions: SESSIONS,
    reports: REPORTS,
    finance: 'ఫైనాన్స్',
    analytics: 'విశ్లేషణలు',
    settings: 'సెట్టింగ్‌లు',
    staffUsers: 'స్టాఫ్ యూజర్లు',
    users: 'వినియోగదారులు',
    myClients: 'నా క్లయింట్లు',
    schedule: 'షెడ్యూల్',
    availability: 'లభ్యత',
    sessionNotes: 'సెషన్ గమనికలు',
    therapyPlans: THERAPY_PLANS,
    messages: 'సందేశాలు',
    progress: PROGRESS,
    homeTasks: HOME_TASKS,
    billing: 'బిల్లింగ్',
    invoices: 'ఇన్‌వాయిస్‌లు',
    catalogue: 'జాబితా',
    payments: 'చెల్లింపులు',
    payroll: 'పేరోల్',
  },
  finance: {
    dashboard: {
      invoiced: 'మొత్తం ఇన్‌వాయిస్ చేయబడింది',
      collected: 'వసూలు చేయబడింది',
      outstanding: 'బాకీ',
      invoices: 'ఇన్‌వాయిస్‌లు',
      revenueTrend: 'ఆదాయం',
      revenueTrendSub: 'వసూలు చేయబడింది, గత 6 నెలలు',
    },
    invoices: {
      title: 'ఇన్‌వాయిస్‌లు',
      count: '{{count}} ఇన్‌వాయిస్‌లు',
      add: 'కొత్త ఇన్‌వాయిస్',
      addSubtitle: 'క్లయింట్ కోసం కొత్త ఇన్‌వాయిస్‌ను సృష్టించు',
      empty: NO_INVOICES,
      searchPlaceholder: 'ఇన్‌వాయిస్ నంబర్ లేదా గమనికల ద్వారా వెతుకు…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      recordPayment: 'చెల్లింపును నమోదు చేయి',
      recordPaymentSubtitle: 'ఈ ఇన్‌వాయిస్‌కు చెల్లింపును నమోదు చేయి',
      col: {
        number: 'ఇన్‌వాయిస్',
        client: CLIENT,
        amount: 'మొత్తం',
        balance: 'నిల్వ',
        due: 'గడువు',
        status: STATUS,
      },
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
    },
    catalogue: {
      title: 'సేవా జాబితా',
      count: '{{count}} సేవలు',
      add: 'సేవను జోడించు',
      addTitle: 'సేవను జోడించు',
      editTitle: 'సేవను సవరించు',
      subtitle: 'డిఫాల్ట్ ధరతో ఒక సేవ; ఇన్‌వాయిస్‌లు దీని నుండి ధర తీసుకుంటాయి.',
      name: 'సేవ పేరు',
      price: 'డిఫాల్ట్ ధర (₹)',
      priceHint: 'ఉదా. 2500',
      description: 'వివరణ (ఐచ్ఛికం)',
      save: 'సేవను సేవ్ చేయి',
      empty: 'ఇంకా సేవలు లేవు — మొదటి ఫీజు జాబితా అంశాన్ని జోడించండి.',
      edit: 'సేవను సవరించు',
      delete: 'సేవను తొలగించు',
      inactive: 'క్రియారహితం',
    },
  },
  reports: {
    recent: 'ఇటీవలి నివేదికలు',
    generate: 'నివేదిక రూపొందించు',
    generateError: 'ఆ నివేదికను ప్రారంభించలేకపోయాం. దయచేసి మళ్ళీ ప్రయత్నించండి.',
    loading: 'నివేదికలు లోడ్ అవుతున్నాయి…',
    error: 'నివేదికలను లోడ్ చేయలేకపోయాం.',
    empty: 'ఇంకా నివేదికలు లేవు — పైన ఒకదాన్ని రూపొందించండి.',
    download: 'డౌన్‌లోడ్',
    field: {
      type: 'నివేదిక రకం',
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      from: 'నుండి',
      to: 'వరకు',
    },
    type: {
      client_progress: 'క్లయింట్ పురోగతి',
      attendance: 'హాజరు',
      revenue: 'ఆదాయం',
    },
    status: {
      queued: 'క్యూలో ఉంది',
      running: 'రూపొందిస్తోంది…',
      succeeded: 'సిద్ధం',
      failed: 'విఫలమైంది',
    },
    col: {
      report: 'నివేదిక',
      status: STATUS,
      created: 'సృష్టించబడింది',
      action: '',
    },
  },
  invoiceStatus: {
    draft: DRAFT,
    sent: 'పంపబడింది',
    partial: 'పాక్షికం',
    paid: PAID,
    overdue: 'గడువు మించింది',
    void: 'రద్దు',
  },
  payroll: {
    title: 'పేరోల్',
    count: '{{count}} రన్‌లు',
    add: 'కొత్త పేరోల్ రన్',
    addSubtitle: 'చెల్లింపు వ్యవధి కోసం పేరోల్ రన్‌ను సృష్టించు',
    empty: 'ఇంకా పేరోల్ రన్‌లు లేవు.',
    colPeriod: 'వ్యవధి',
    colTotal: 'మొత్తం',
    colStatus: STATUS,
    form: {
      period: 'చెల్లింపు వ్యవధి',
      periodHint: 'ఉదా. జూన్ 2026',
      start: 'వ్యవధి ప్రారంభం',
      end: 'వ్యవధి ముగింపు',
      notes: 'గమనికలు',
      submit: 'రన్ సృష్టించు',
      therapist: THERAPIST,
      selectTherapist: 'థెరపిస్ట్‌ను ఎంచుకోండి',
      gross: 'స్థూల చెల్లింపు (₹)',
      sessions: SESSIONS,
      addSubmit: 'పేస్లిప్ జోడించు',
    },
    detail: {
      title: 'పేరోల్ రన్',
      total: 'మొత్తం: {{amount}}',
      addPayslip: 'పేస్లిప్ జోడించు',
      addSubtitle: 'ఈ రన్‌కు థెరపిస్ట్ పేస్లిప్‌ను జోడించు',
      process: 'ప్రాసెస్',
      empty: 'ఇంకా పేస్లిప్‌లు లేవు.',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colGross: 'స్థూలం',
    },
  },
  payrollStatus: {
    draft: DRAFT,
    processed: 'ప్రాసెస్ చేయబడింది',
    paid: PAID,
  },
  paymentMethod: {
    cash: 'నగదు',
    card: 'కార్డు',
    upi: 'UPI',
    bank_transfer: 'బ్యాంక్ బదిలీ',
    razorpay: 'Razorpay',
  },
  home: {
    assign: 'పనిని కేటాయించు',
    assignSubtitle: 'ఈ క్లయింట్ కోసం ఇంటి-ప్రోగ్రామ్ పనిని జోడించు',
  },
  homeCategory: {
    social: 'సామాజికం',
    sensory: 'ఇంద్రియ',
    cognitive: 'జ్ఞానపరమైన',
    communication: 'సంభాషణ',
    motor: 'మోటార్',
    other: 'ఇతర',
  },
  analytics: {
    title: 'విశ్లేషణలు',
    subtitle: 'క్లినిక్ పనితీరు ఒక్క చూపులో',
    financeSubtitle: 'ఆదాయం మరియు వసూళ్లు ఒక్క చూపులో',
    totalClients: 'మొత్తం క్లయింట్లు',
    completedSessions: 'పూర్తయిన సెషన్లు',
    sessionsByStatus: 'స్థితి ప్రకారం సెషన్లు',
    clientsByStatus: 'స్థితి ప్రకారం క్లయింట్లు',
    invoicesByStatus: 'స్థితి ప్రకారం ఇన్‌వాయిస్‌లు',
    collections: 'ఇన్‌వాయిస్ vs వసూలు (₹)',
  },
  settings: {
    title: 'సెట్టింగ్‌లు',
    subtitle: 'మీ క్లినిక్ ప్రొఫైల్‌ను నిర్వహించు',
    name: 'క్లినిక్ పేరు',
    legalName: LEGAL_NAME,
    email: CONTACT_EMAIL,
    phone: CONTACT_PHONE,
    timezone: TIMEZONE,
    gstin: 'GSTIN',
    address: 'చిరునామా',
    line1: ADD_LINE_1,
    line2: 'చిరునామా లైన్ 2',
    city: CITY,
    state: STATE_LABEL,
    postalCode: POSTAL_CODE,
    country: COUNTRY_ISO,
    save: SAVE_CHANGES,
    saved: 'సెట్టింగ్‌లు సేవ్ చేయబడ్డాయి.',
    tabs: { profile: 'ప్రొఫైల్', notifications: 'నోటిఫికేషన్‌లు', security: 'భద్రత' },
    notifications: {
      sessionReminders: 'సెషన్ రిమైండర్‌లు',
      sessionRemindersDesc: 'రాబోయే సెషన్‌లకు ముందు ఇమెయిల్ రిమైండర్‌లు.',
      paymentAlerts: 'చెల్లింపు హెచ్చరికలు',
      paymentAlertsDesc: 'ఇన్‌వాయిస్‌లు చెల్లించినప్పుడు లేదా బకాయి ఉన్నప్పుడు తెలియజేయండి.',
      progressReports: 'పురోగతి నివేదికలు',
      progressReportsDesc: 'పురోగతి నివేదిక సిద్ధంగా ఉన్నప్పుడు తెలియజేయండి.',
      systemUpdates: 'సిస్టమ్ నవీకరణలు',
      systemUpdatesDesc: 'ప్లాట్‌ఫారమ్ మరియు నిర్వహణ ప్రకటనలు.',
    },
    security: {
      subtitle: 'మీ ఖాతా పాస్‌వర్డ్‌ను మార్చండి. ఈ పరికరంలో మీరు సైన్ ఇన్ చేసే ఉంటారు.',
    },
  },
  messages: {
    title: 'సందేశాలు',
    new: 'కొత్త సందేశం',
    newSubtitle: 'ఒక సంప్రదింపుతో సంభాషణను ప్రారంభించు',
    empty: 'ఇంకా సందేశాలు లేవు.',
    conversation: 'సంభాషణ',
    composer: 'సందేశాన్ని టైప్ చేయండి…',
    noContacts: 'సందేశం పంపడానికి సంప్రదింపులు లేవు.',
    selectContact: 'సంప్రదింపును ఎంచుకోండి',
    startChat: 'చాట్ ప్రారంభించు',
    pickConversation: 'చాట్ ప్రారంభించడానికి సంభాషణను ఎంచుకోండి',
  },
  sa: {
    dashboard: {
      title: 'ప్లాట్‌ఫారమ్ అవలోకనం',
      subtitle: 'TherapyOS లోని అన్ని క్లినిక్‌లు ఒక్క చూపులో',
      empty: 'ఇంకా డేటా లేదు.',
      totalClinics: 'మొత్తం క్లినిక్‌లు',
      activeClinics: 'యాక్టివ్ క్లినిక్‌లు',
      mrr: 'నెలవారీ పునరావృత ఆదాయం',
      health: 'ఆరోగ్యం (G / A / R)',
      healthHint: 'ఆకుపచ్చ / అంబర్ / ఎరుపు',
      topBySessions: 'సెషన్ల ప్రకారం అగ్ర క్లినిక్‌లు',
      topByRevenue: 'ఆదాయం ప్రకారం అగ్ర క్లినిక్‌లు (₹)',
    },
    clinics: {
      title: 'క్లినిక్‌లు',
      count: '{{count}} క్లినిక్‌లు',
      add: 'కొత్త క్లినిక్',
      empty: 'ఇంకా క్లినిక్‌లు ఆన్‌బోర్డ్ చేయబడలేదు.',
      searchPlaceholder: 'పేరు, ప్లాన్ లేదా స్థితి ద్వారా వెతుకు…',
      colName: CLIENT,
      colStatus: STATUS,
      colPlan: PLAN,
      colMrr: MRR,
      colTherapists: THERAPIST,
      colActiveClients: 'యాక్టివ్ క్లయింట్లు',
    },
    subscriptions: {
      title: 'సబ్‌స్క్రిప్షన్లు',
      count: '{{count}} క్లినిక్‌లు',
      empty: 'ఇంకా సబ్‌స్క్రిప్షన్లు లేవు.',
      col: {
        clinic: 'క్లినిక్',
        plan: PLAN,
        status: STATUS,
        mrr: MRR,
        renews: 'పునరుద్ధరణ / ట్రయల్ ముగింపు',
        actions: '',
      },
      markPaid: 'చెల్లించినట్లు గుర్తించు',
      status: {
        active: ACTIVE,
        trialing: TRIAL,
        past_due: 'బాకీ',
        suspended: SUSPENDED,
        cancelled: 'రద్దు',
        none: 'ప్లాన్ లేదు',
      },
    },
    usage: {
      title: 'వినియోగం & ఆరోగ్యం',
      healthSummary: '{{green}} ఆకుపచ్చ · {{amber}} అంబర్ · {{red}} ఎరుపు',
      empty: 'ఇంకా వినియోగ డేటా లేదు.',
      col: {
        clinic: 'క్లినిక్',
        health: 'ఆరోగ్యం',
        sessions: 'సెషన్లు (30రో)',
        whatsapp: 'వాట్సాప్',
        sms: 'SMS',
        pdfs: 'PDFలు',
        storage: 'స్టోరేజ్',
        users: 'యాక్టివ్ యూజర్లు',
      },
      health: {
        green: 'ఆరోగ్యకరం',
        amber: 'ప్రమాదంలో',
        red: 'క్లిష్టం',
        unknown: 'తెలియదు',
      },
    },
    staff: {
      title: 'స్టాఫ్ యూజర్లు',
      count: '{{count}} స్టాఫ్ ఖాతాలు',
      add: 'స్టాఫ్ యూజర్ జోడించు',
      empty: 'ఇంకా స్టాఫ్ ఖాతాలు లేవు.',
      active: ACTIVE,
      inactive: 'నిలిపివేయబడింది',
      enable: 'ప్రారంభించు',
      disable: 'నిలిపివేయి',
      col: {
        member: 'సభ్యుడు',
        role: 'పాత్ర',
        status: STATUS,
        lastLogin: 'చివరి లాగిన్',
        actions: '',
      },
      role: {
        PLATFORM_OWNER: 'ప్లాట్‌ఫారమ్ యజమాని',
        CUSTOMER_SUCCESS: 'కస్టమర్ సక్సెస్',
        SUPPORT: 'సపోర్ట్',
        READONLY_AUDITOR: 'రీడ్-ఓన్లీ ఆడిటర్',
      },
      form: {
        fullName: FULL_NAME,
        email: EMAIL,
        role: 'పాత్ర',
        submit: 'ఖాతా సృష్టించు',
        error: 'ఖాతాను సృష్టించలేకపోయాం (ఇమెయిల్ వాడుకలో ఉండవచ్చు).',
      },
      created: {
        title: 'ఖాతా సృష్టించబడింది',
        intro: '{{email}} తో ఈ ఆధారాలను సురక్షితంగా పంచుకోండి.',
        copy: 'కాపీ',
        warning: 'ఒక్కసారి మాత్రమే చూపబడుతుంది — సభ్యుడు మొదటి లాగిన్‌లో ఈ పాస్‌వర్డ్‌ను మార్చాలి.',
        done: 'పూర్తయింది',
      },
    },
    clinicStatus: {
      active: ACTIVE,
      trial: TRIAL,
      trialing: TRIAL,
      suspended: SUSPENDED,
      cancelled: CANCELLED,
      past_due: 'బాకీ',
    },
    detail: {
      back: 'క్లినిక్‌లకు తిరిగి',
      notFound: 'క్లినిక్ కనుగొనబడలేదు.',
      overview: 'అవలోకనం',
      legalName: LEGAL_NAME,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE,
      timezone: TIMEZONE,
      createdAt: 'ఆన్‌బోర్డ్ చేయబడింది',
      subscription: SUBSCRIPTION,
      noSubscription: 'యాక్టివ్ సబ్‌స్క్రిప్షన్ లేదు.',
      plan: PLAN,
      subStatus: STATUS,
      mrr: MRR,
      periodEnd: 'పునరుద్ధరణ',
      therapists: THERAPIST,
      activeClients: 'యాక్టివ్ క్లయింట్లు',
      sessions: SESSIONS,
      invoiced: 'ఇన్‌వాయిస్ చేయబడింది',
      recentAudit: 'ఇటీవలి కార్యకలాపం',
      noAudit: 'ఇటీవలి కార్యకలాపం లేదు.',
    },
    audit: {
      title: 'ఆడిట్ లాగ్',
      subtitle: 'అన్ని క్లినిక్‌లలో ప్లాట్‌ఫారమ్-వ్యాప్త కార్యకలాపం',
      empty: 'ఈ ఫిల్టర్‌లకు ఆడిట్ ఎంట్రీలు సరిపోలడం లేదు.',
      allClinics: 'అన్ని క్లినిక్‌లు',
      filterClinic: 'క్లినిక్ ద్వారా ఫిల్టర్',
      filterAction: 'చర్య ద్వారా ఫిల్టర్…',
      filterFrom: 'తేదీ నుండి',
      filterTo: 'తేదీ వరకు',
      colTime: TIME,
      colClinic: 'క్లినిక్',
      colActor: 'నటుడు',
      colAction: ACTION,
      colEntity: 'ఎంటిటీ',
    },
    settings: {
      title: 'ప్లాట్‌ఫారం సెట్టింగ్‌లు',
      subtitle: 'ఫీచర్ ఫ్లాగ్‌లు మరియు ప్లాట్‌ఫారం కాన్ఫిగరేషన్',
      flags: 'ఫీచర్ ఫ్లాగ్‌లు',
      empty: 'ఇంకా ఫీచర్ ఫ్లాగ్‌లు లేవు. క్రింద ఒకటి జోడించండి.',
      enabled: 'ప్రారంభించబడింది',
      disabled: SUSPENDED,
      enable: 'ఆన్ చేయి',
      disable: 'నిలిపివేయి',
      addKey: 'ఒక ఫీచర్ ఫ్లాగ్ జోడించండి',
      addPlaceholder: 'ఉదా. parent_app_v2',
      add: 'జోడించు',
      col: {
        key: 'ఫ్లాగ్',
        state: 'స్థితి',
        updated: 'నవీకరించబడింది',
      },
    },
    wizard: {
      title: 'క్లినిక్‌ను ఆన్‌బోర్డ్ చేయి',
      subtitle: 'క్లినిక్, దాని మొదటి అడ్మిన్ మరియు యాక్టివ్ సబ్‌స్క్రిప్షన్‌ను సృష్టించు',
      stepOf: '{{total}} లో దశ {{step}}',
      clinicName: 'క్లినిక్ పేరు',
      legalName: LEGAL_NAME,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE,
      line1: ADD_LINE_1,
      city: CITY,
      state: STATE_LABEL,
      postalCode: POSTAL_CODE,
      country: 'దేశం (ISO 3166-1 alpha-2)',
      adminName: 'మొదటి అడ్మిన్ పేరు',
      adminEmail: 'మొదటి అడ్మిన్ ఇమెయిల్',
      planSlug: PLAN,
      trialDays: 'ట్రయల్ రోజులు (ఐచ్ఛికం)',
      back: 'వెనక్కి',
      next: 'తదుపరి',
      submit: 'క్లినిక్‌ను ఆన్‌బోర్డ్ చేయి',
    },
  },
  banner: {
    impersonation:
      '⚠ మీరు {{clinic}} ను {{staff}} గా చూస్తున్నారు — అన్ని చర్యలు ఆడిట్-లాగ్ చేయబడతాయి. సెషన్ {{remaining}} లో ముగుస్తుంది.',
    readOnly:
      'ఖాతా రీడ్-ఓన్లీ మోడ్‌లో ఉంది — కొనసాగించడానికి మీ సబ్‌స్క్రిప్షన్‌ను పునరుద్ధరించండి.',
  },
} as const;
